import globalIP from '@/GlobelIP';
import React, { useState, useEffect } from 'react';
import {
    Modal,
    Button,
    Stack,
    DatePicker,
    Input,
    useToaster,
    Message,
    Panel,
    Table,
    Toggle,
    Whisper,
    Tooltip,
    IconButton
} from 'rsuite';
import { differenceInDays } from 'date-fns';
import EditIcon from '@rsuite/icons/Edit';
import { Icon } from '@rsuite/icons';
import CheckOutlineIcon from '@rsuite/icons/CheckOutline';
import CheckIcon from '@rsuite/icons/Check';
import CloseIcon from '@rsuite/icons/Close';
import axios from 'axios';

interface RowDatafairdata {
    id: string; // or number, depending on your data
    attributes: {
        location: string;
        fairName: string;
    };
}
const { Column, HeaderCell, Cell } = Table;

const ModalComponent = ({ open, onClose, fairdata, fairStatuses, fairmeta, setFairData, fetchDataEnc }) => {

    const [days, setDays] = useState('0')
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [editingId, setEditingId] = useState<string | null>(null);

    // const handleStartDateChange = (value) => {
    //     const currentDate = new Date();
    //     if (value && value < currentDate) {
    //         value = currentDate;
    //     }
    //     setStartDate(value);
    //     updateDays(value, endDate);
    // };

    const handleStartDateChange = (value) => {
        if (endDate && value && value > endDate) {
            // if user picks start after end → reset end date
            setEndDate(null);
            setDays("0");
        } else if (!value) {
            setEndDate(null);
        }
        setStartDate(value);
        updateDays(value, endDate);
    };

    // const handleEndDateChange = (value) => {
    //     const currentDate = new Date();
    //     if (value && value < currentDate) {
    //         value = currentDate;
    //     }
    //     if (startDate && value && value < startDate) {
    //         value = startDate;
    //     }
    //     setEndDate(value);
    //     updateDays(startDate, value);
    // };

    const handleEndDateChange = (value) => {
        if (startDate && value && value < startDate) {
            // if end before start → not allowed
            toaster.push(
                <Message showIcon type="error">
                    End Date cannot be before Start Date
                </Message>,
                { placement: "topCenter" }
            );
            return;
        }
        setEndDate(value);
        updateDays(startDate, value);
    };


    // const updateDays = (start, end) => {
    //     if (start && end) {
    //         const daysDifference = differenceInDays(end, start);
    //         setDays(String(daysDifference));
    //     }
    // };

    const updateDays = (start, end) => {
        if (start && end) {
            const daysDifference = differenceInDays(end, start) + 1; // +1 for same day
            setDays(daysDifference >= 1 ? String(daysDifference) : "0");
        } else {
            setDays("0");
        }
    };


    const [fairm, setFairm] = useState({
        fairCode: "",
        fairName: "",
        sessionFair: "",
        fairdays: "",
        location: "",
        fairstatus: "",
        fairStartDate: "",
        fairEndDate: "",

    });
    const handleInputChange = (inputName, event) => {
        let value;
        if (event && event.target) {
            value = event.target.value;
        } else {
            value = event;
        }
        setFairm({ ...fairm, [inputName]: value });

    }
    const toaster = useToaster()
    const fairmaster = `${globalIP}/api/fair-masters`;
    // const submit = async (e) => {
    //     if (startDate == null) {
    //         toaster.push(<Message showIcon type='error' >
    //             Please Select Fair Date.
    //         </Message>, { placement: 'topCenter' });
    //     }
    //     else if (endDate == null) {
    //         toaster.push(<Message showIcon type='error' >
    //             Please add Fair Date.
    //         </Message>, { placement: 'topCenter' });
    //     } else if (fairm.fairName == '') {
    //         toaster.push(<Message showIcon type='error' >
    //             Please add Fair Name.
    //         </Message>, { placement: 'topCenter' });
    //     }
    //     else {
    //         e.preventDefault();
    //         const { data: fircode } = await axios.get(`${globalIP}/api/fair-masters?populate=*`);
    //         const nextCode = fircode.meta.pagination.total + 1;
    //         const updatePromises = fairdata.map((fair) => {
    //             // Create a new FormData instance for each fair
    //             const updateFormData = new FormData();
    //             // Append fair data with the updated status
    //             updateFormData.append("data", JSON.stringify({
    //                 ...fair,
    //                 fairstatus: 'Inactive',
    //             }));

    //             // Make the PUT request for each fair
    //             return fetch(`${globalIP}/api/fair-masters/${fair.id}`, {
    //                 method: 'PUT',
    //                 body: updateFormData,
    //             });
    //         });

    //         // Wait for all updates to complete before adding the new fair
    //         await Promise.all(updatePromises);
    //         const formData = new FormData();
    //         // Set all existing fairs' statuses to inactive

    //         formData.append("data", JSON.stringify({
    //             ...fairm,
    //             fairCode: `FAR-${nextCode.toString().padStart(3, "0")}`,
    //             fairStartDate: startDate ? startDate.toISOString().slice(0, 10) : null,
    //             fairEndDate: endDate ? endDate.toISOString().slice(0, 10) : null,
    //             fairdays: String(days),
    //             fairstatus: 'Active'
    //         }));
    //         fetch(fairmaster, {
    //             method: 'POST',
    //             body: formData,
    //         })
    //             .then(response => response.json())
    //             .then(data => {
    //                 console.log(data);
    //                 handleOpen();
    //                 // Refresh page after 2 seconds (2000 milliseconds)
    //             })
    //             .catch((error) => {
    //                 console.error(error)
    //             });
    //     }
    // };

    const submit = async (e) => {
        e.preventDefault();

        // ---- Validation ----
        if (!startDate) {
            toaster.push(<Message showIcon type="error">Please Select Fair Date.</Message>, { placement: 'topCenter' });
            return;
        }
        if (!endDate) {
            toaster.push(<Message showIcon type="error">Please add Fair Date.</Message>, { placement: 'topCenter' });
            return;
        }
        if (!fairm.fairName || fairm.fairName.trim() === '') {
            toaster.push(<Message showIcon type="error">Please add Fair Name.</Message>, { placement: 'topCenter' });
            return;
        }

        const fairNameRegex = /^[A-Za-z0-9\s\-&,\.@]+$/;
        if (!fairNameRegex.test(fairm.fairName)) {
            toaster.push(
                <Message showIcon type="error">
                    Fair Name can only contain letters, numbers, spaces and - , & . @
                </Message>,
                { placement: "topCenter" }
            );
            return;
        }

        // ---- Year Session Validation (optional) ----
        if (fairm.sessionFair && fairm.sessionFair.trim() !== "") {
            const sessionRegex = /^[A-Za-z0-9]+$/;
            if (!sessionRegex.test(fairm.sessionFair)) {
                toaster.push(
                    <Message showIcon type="error">
                        Year Session can only contain letters and numbers, no special characters.
                    </Message>,
                    { placement: 'topCenter' }
                );
                return;
            }
        }

        // ---- Location Validation (optional) ----
        if (fairm.location && fairm.location.trim() !== "") {
            const locationRegex = /^[A-Za-z0-9\s\-,]+$/;
            if (!locationRegex.test(fairm.location)) {
                toaster.push(
                    <Message showIcon type="error">
                        Location can only contain letters, numbers, spaces, dash (-) and comma (,). No other special characters allowed.
                    </Message>,
                    { placement: 'topCenter' }
                );
                return;
            }
        }


        try {
            const formData = new FormData();
            formData.append("data", JSON.stringify({
                ...fairm,
                fairStartDate: startDate ? startDate.toISOString().slice(0, 10) : null,
                fairEndDate: endDate ? endDate.toISOString().slice(0, 10) : null,
                fairdays: String(days),
                fairstatus: 'Active'
            }));

            if (editingId) {
                // ---------------- UPDATE MODE ----------------
                await fetch(`${globalIP}/api/fair-masters/${editingId}`, {
                    method: "PUT",
                    body: formData,
                });
                setEditingId(null); // exit edit mode
            } else {
                // ---------------- CREATE MODE ----------------
                // deactivate all current fairs
                const updatePromises = fairdata.map((fair) => {
                    const updateFormData = new FormData();
                    updateFormData.append("data", JSON.stringify({
                        ...fair,
                        fairstatus: "Inactive",
                    }));
                    return fetch(`${globalIP}/api/fair-masters/${fair.id}`, {
                        method: "PUT",
                        body: updateFormData,
                    });
                });
                await Promise.all(updatePromises);

                // generate next code
                const { data: fircode } = await axios.get(`${globalIP}/api/fair-masters?populate=*`);
                const nextCode = fircode.meta.pagination.total + 1;

                formData.set("data", JSON.stringify({
                    ...fairm,
                    fairCode: `FAR-${nextCode.toString().padStart(3, "0")}`,
                    fairStartDate: startDate ? startDate.toISOString().slice(0, 10) : null,
                    fairEndDate: endDate ? endDate.toISOString().slice(0, 10) : null,
                    fairdays: String(days),
                    fairstatus: "Active",
                }));

                await fetch(fairmaster, {
                    method: "POST",
                    body: formData,
                });
            }

            fetchDataEnc(); // refresh table
            handleOpen();   // success popup
        } catch (error) {
            console.error("Error in submit:", error);
            toaster.push(<Message showIcon type="error">Something went wrong.</Message>, { placement: "topCenter" });
        }
    };

    const [open1, setOpen1] = useState(false);
    const handleOpen = () => setOpen1(true);
    const handleClose = () => {
        fetchDataEnc();
        setOpen1(false);
        setFairm({
            fairCode: "",
            fairName: "",
            sessionFair: "",
            fairdays: "",
            location: "",
            fairstatus: "",
            fairStartDate: "",
            fairEndDate: "",
        });
        setStartDate(null);
        setEndDate(null);
        setDays('0')
    }
    const handleToggleChange = async (rowData, checked) => {
        try {
            const updatedFair = {
                ...rowData.attributes,
                fairstatus: checked ? 'Active' : 'Inactive',
            };

            // If activating a fair, deactivate all other fairs
            if (checked) {
                const deactivatePromises = fairdata
                    .filter((fair) => fair.id !== rowData.id && fair.attributes.fairstatus === 'Active')
                    .map((fair) => {
                        return fetch(`${globalIP}/api/fair-masters/${fair.id}`, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({ data: { ...fair.attributes, fairstatus: 'Inactive' } }),
                        });
                    });

                // Wait for all deactivations to complete before updating the current fair
                await Promise.all(deactivatePromises);
            }

            // Update the current fair's status
            await fetch(`${globalIP}/api/fair-masters/${rowData.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ data: updatedFair }),
            });

            // Update the state based on the new status
            setFairData((prevFairData) => {
                return prevFairData.map((fair) => {
                    if (fair.id === rowData.id) {
                        return { ...fair, attributes: updatedFair };
                    } else {
                        return fair;
                    }
                });
            });
        } catch (error) {
            console.error('Error updating fair status:', error);
        }
        fetchDataEnc();
    };
    const [searchQuery, setSearchQuery] = useState('');
    const handleSearch = (value) => {
        setSearchQuery(value);
    }
    const [editedRowIds, setEditedRowIds] = useState<string[]>([]);
    const [editedData, setEditedData] = useState<
        Record<string, Partial<RowDatafairdata['attributes']>>
    >({});
    const handleInputChangefairname = (rowId, fieldName, value) => {
        setEditedData(prevData => {
            const updatedData = { ...prevData };
            if (!updatedData[rowId]) {
                updatedData[rowId] = { ...fairdata.find(row => row.id === rowId).attributes };
            }
            updatedData[rowId][fieldName] = value;
            return updatedData;
        });
    };
    // const handleEditRow = rowData => {
    //     setEditedRowIds(prevRowIds => [...prevRowIds, rowData.id]);
    //     setEditedData(prevData => ({
    //         ...prevData,
    //         [rowData.id]: { ...rowData.attributes }
    //     }));
    // };
    const handleCancelEdit = () => {
        setEditingId(null);  // exit edit mode
        setFairm({
            fairCode: "",
            fairName: "",
            sessionFair: "",
            fairdays: "",
            location: "",
            fairstatus: "",
            fairStartDate: "",
            fairEndDate: "",
        });
        setStartDate(null);
        setEndDate(null);
        setDays("0");
    };


    const handleEditRow = (rowData) => {
        setEditingId(rowData.id);
        setFairm({
            fairCode: rowData.attributes.fairCode,
            fairName: rowData.attributes.fairName,
            sessionFair: rowData.attributes.sessionFair,
            fairdays: rowData.attributes.fairdays,
            location: rowData.attributes.location,
            fairstatus: rowData.attributes.fairstatus,
            fairStartDate: rowData.attributes.fairStartDate,
            fairEndDate: rowData.attributes.fairEndDate,
        });
        setStartDate(rowData.attributes.fairStartDate ? new Date(rowData.attributes.fairStartDate) : null);
        setEndDate(rowData.attributes.fairEndDate ? new Date(rowData.attributes.fairEndDate) : null);
        setDays(rowData.attributes.fairdays || '0');
    };

    const handleSavefairmaster = async (rowId: string) => {
        try {
            const rowData = fairdata.find(row => row.id === rowId);
            if (!rowData) {
                console.error('Row data not found.');
                return;
            }
            const editedFairName = editedData[rowId]?.fairName;
            if (!editedFairName || editedFairName.trim() === '') {
                toaster.push(
                    <Message showIcon type="error">
                        Fair Name is required.
                    </Message>,
                    { placement: 'topEnd' }
                );
                return;
            }
            const updatedRowData: RowDatafairdata = {
                ...rowData,
                attributes: { ...rowData.attributes, ...editedData[rowId] }
            };

            const response = await fetch(`${globalIP}/api/fair-masters/${rowData.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ data: updatedRowData.attributes })
            });
            if (response.ok) {
                // If the API call is successful, update the data
                fetchDataEnc();
                setEditedRowIds(prevRowIds => prevRowIds.filter(id => id !== rowId));
            } else {
                // Handle error if needed
                console.error('Failed to save data');
            }
        } catch (error) {
            console.error('Error occurred while saving data', error);
        }
    };
    return (
        <>
            <Modal open={open} onClose={onClose} backdrop='static' size='full'>
                <Modal.Header>
                    <Modal.Title><b>Create Bucket</b></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Stack spacing={5} alignItems='flex-end'>
                        <Stack direction='column' alignItems='flex-start' >
                            <Stack><p>From Date </p><p style={{ color: 'red' }}>*</p></Stack>
                            <DatePicker
                                id="startDatePicker"
                                format="dd/MM/yyyy"
                                value={startDate}
                                onChange={(value) => handleStartDateChange(value)}
                            />
                        </Stack>
                        <Stack direction='column' alignItems='flex-start' >
                            <Stack><p>End Date </p><p style={{ color: 'red' }}>*</p></Stack>
                            <DatePicker
                                id="endDatePicker"
                                format="dd/MM/yyyy"
                                value={endDate}
                                onChange={(value) => handleEndDateChange(value)}
                                disabledDate={(date) => startDate && date < startDate}
                                disabled={!startDate}
                            />
                        </Stack>

                        <Stack direction='column' alignItems='flex-start' >
                            <Stack><p>Fair Name </p><p style={{ color: 'red' }}>*</p></Stack>
                            <Input style={{ width: 250 }} id='fairName' name="fairName" value={fairm && fairm.fairName ? fairm.fairName : ''} onChange={value => handleInputChange('fairName', value)} />
                        </Stack><Stack direction='column' alignItems='flex-start' >
                            <label>Year Session</label>
                            <Input style={{ width: 100 }} id='sessionFair' name="sessionFair" value={fairm && fairm.sessionFair ? fairm.sessionFair : ''} onChange={value => handleInputChange('sessionFair', value)} />
                        </Stack><Stack direction='column' alignItems='flex-start' >
                            <label>Fair Days</label>
                            <Input style={{ width: 80 }} value={days} readOnly />
                        </Stack><Stack direction='column' alignItems='flex-start' >
                            <label>Location</label>
                            <Input id='location' name="location" value={fairm && fairm.location ? fairm.location : ''} onChange={value => handleInputChange('location', value)} />
                        </Stack>
                        {/* <Button appearance='primary' color='cyan' onClick={submit}>Save</Button> */}
                        <Stack direction="row" spacing={10}>
                            <Button appearance="primary" color="cyan" onClick={submit}>
                                {editingId ? "Update" : "Save"}
                            </Button>

                            {editingId && (
                                <Button appearance="default" onClick={handleCancelEdit}>
                                    Cancel
                                </Button>
                            )}
                        </Stack>


                    </Stack>
                    <Panel>
                        <Table height={420} data={fairdata.filter(item => {
                            const fairName = item.attributes.fairName ? item.attributes.fairName.toLowerCase() : '';
                            const fairCode = item.attributes.fairCode ? item.attributes.fairCode.toLowerCase() : '';
                            const sessionFair = item.attributes.sessionFair ? item.attributes.sessionFair.toLowerCase() : '';
                            const location = item.attributes.location ? item.attributes.location.toLowerCase() : '';
                            return (
                                // Master Search
                                fairName.includes(searchQuery.toLowerCase()) ||
                                fairCode.includes(searchQuery.toLowerCase()) ||
                                sessionFair.includes(searchQuery.toLowerCase()) ||
                                location.includes(searchQuery.toLowerCase())
                                // Master Search
                            );
                        })
                            .sort((a, b) => {
                                // Sorting by fairCode (you can replace this with any other field)
                                return b.attributes.fairCode.localeCompare(a.attributes.fairCode);
                            })
                        }
                            rowHeight={60}
                            rowKey="id"
                            bordered
                            cellBordered
                        >
                            <Column width={80} align='center'>
                                <HeaderCell><b>S. NO</b></HeaderCell>
                                <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
                            </Column>
                            <Column width={160} align='center'>
                                <HeaderCell><b>Fair Code</b></HeaderCell>
                                <Cell dataKey={'attributes.fairCode'} />
                            </Column>
                            <Column width={200} align='center' >
                                <HeaderCell><b>Fair Name</b></HeaderCell>
                                <Table.Cell>
                                    {rowData =>
                                        editedRowIds.includes(rowData.id) ? (
                                            <Input
                                                value={editedData[rowData.id]?.fairName || ''}
                                                onChange={value =>
                                                    handleInputChangefairname(rowData.id, 'fairName', value)
                                                }
                                            />
                                        ) : (
                                            rowData.attributes.fairName
                                        )
                                    }
                                </Table.Cell>
                            </Column>
                            <Column width={160} align='center'>
                                <HeaderCell><b>Session</b></HeaderCell>
                                <Cell dataKey={'attributes.sessionFair'} />
                            </Column>
                            <Column width={160} align='center'>
                                <HeaderCell><b>Fair Days</b></HeaderCell>
                                <Cell dataKey={'attributes.fairdays'} />
                            </Column>
                            <Column width={160} align='center'>
                                <HeaderCell><b>Location</b></HeaderCell>
                                <Table.Cell >
                                    {rowData =>
                                        editedRowIds.includes(rowData.id) ? (
                                            <Input
                                                value={editedData[rowData.id]?.location || ''}
                                                onChange={value =>
                                                    handleInputChangefairname(rowData.id, 'location', value)
                                                }
                                            />
                                        ) : (
                                            rowData.attributes.location
                                        )
                                    }
                                </Table.Cell>
                            </Column>
                            <Table.Column width={160} align='center'>
                                <HeaderCell><b>Status</b></HeaderCell>
                                <Table.Cell >
                                    {(rowData) => (
                                        <Toggle
                                            checked={fairStatuses[rowData.id] === 'Active'}
                                            onChange={(checked) => handleToggleChange(rowData, checked)}
                                        />
                                    )}
                                </Table.Cell>
                            </Table.Column>
                            <Column width={180} align='center'>
                                <HeaderCell><b>Action</b></HeaderCell>
                                <Table.Cell >

                                    {rowData =>
                                        editedRowIds.includes(rowData.id) ? (
                                            <div>
                                                <IconButton
                                                    size="sm"
                                                    icon={<CheckIcon />}
                                                    active
                                                    onClick={() => handleSavefairmaster(rowData.id)}
                                                    style={{ marginRight: '10px' }}
                                                // disabled={
                                                //     !editedData[rowData.id]?.CategoryName ||
                                                //     editedData[rowData.id]?.CategoryName.trim() === ''
                                                // }
                                                />
                                                <IconButton
                                                    size="sm"
                                                    icon={<CloseIcon />}
                                                    active
                                                    onClick={() =>
                                                        setEditedRowIds(prevRowIds =>
                                                            prevRowIds.filter(id => id !== rowData.id)
                                                        )
                                                    }
                                                />
                                            </div>
                                        ) : (
                                            // <div>
                                            //     <Whisper speaker={<Tooltip>Update</Tooltip>}>
                                            //         <IconButton
                                            //             size="sm"
                                            //             icon={<EditIcon />}
                                            //             active
                                            //             onClick={() => handleEditRow(rowData)}
                                            //         />
                                            //     </Whisper>
                                            // </div>
                                            <div>
                                                <Whisper speaker={<Tooltip>Update</Tooltip>}>
                                                    <IconButton
                                                        size="sm"
                                                        icon={<EditIcon />}
                                                        active
                                                        onClick={() => handleEditRow(rowData)} // fills form with row data
                                                    />
                                                </Whisper>
                                            </div>
                                        )}


                                </Table.Cell>
                            </Column>
                        </Table>
                    </Panel>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={onClose} appearance="primary" color='cyan'>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal open={open1} onClose={handleClose}>

                <Modal.Body>
                    <Stack direction='column'>
                        <Icon as={CheckOutlineIcon} color='cyan' style={{ fontSize: '100px', marginBottom: '20px' }} />
                        <b>Saved Successfully</b>
                    </Stack>
                </Modal.Body>
                <Modal.Footer>

                    <Button onClick={handleClose} appearance="primary" color='cyan'>
                        Ok
                    </Button>

                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ModalComponent;
